import React from "react";

const FormContext = React.createContext({
  recaptcha: false,
  onSubmitted: () => false,
});
export default FormContext;
